import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../utils/httpClient';

export const deletePolicyTemplatesByID = createAsyncThunk<string, string>(
  'mdmPolicyTemplates/data/deletePolicyTemplatesByID',
  async (policyTemplatesId: string) => {
    await api.delete(`/mdm/policy_templates/${policyTemplatesId}`)
    return policyTemplatesId
  }
);

export const patchPriorityTemplatesByID = createAsyncThunk<{ policyTemplatesId: string, Priority: number }, { policyTemplatesId: string, Priority: number }>(
  'mdmPolicyTemplates/data/patchPriorityTemplatesByID',
  async ({ policyTemplatesId, Priority }: { policyTemplatesId: string, Priority: number }) => {
    await api.patch(`/mdm/policy_templates/priority/${policyTemplatesId}`, { Priority })
    return { policyTemplatesId, Priority }
  }
);

const initialState = {
  deletePolicyTemplatesByID: {
    loading: false,
    success: false,
    error: false,
    deletedId: null as string | null
  },
  patchPriorityTemplatesByIDState: {
    loading: false,
    success: false,
    error: false,
    policyTemplatesId: null as string | null,
    Priority: null as number | null
  },
}

const mdmPolicyTemplatesDataSlice = createSlice({
  name: "mdmPolicyTemplates/data",
  initialState: initialState,
  reducers: {
    resetDeletePolicyTemplatesByID: (state) => {
      state.deletePolicyTemplatesByID = initialState.deletePolicyTemplatesByID
    },
    resetPatchPriorityTemplatesByIDState: (state) => {
      state.patchPriorityTemplatesByIDState = initialState.patchPriorityTemplatesByIDState
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deletePolicyTemplatesByID.pending, (state) => {
        state.deletePolicyTemplatesByID = {
          loading: true,
          success: false,
          error: false,
          deletedId: null
        };
      })
      .addCase(deletePolicyTemplatesByID.fulfilled, (state, action) => {
        state.deletePolicyTemplatesByID = {
          loading: false,
          success: true,
          error: false,
          deletedId: action.payload
        };
      })
      .addCase(deletePolicyTemplatesByID.rejected, (state) => {
        state.deletePolicyTemplatesByID = {
          loading: false,
          success: false,
          error: true,
          deletedId: null
        };
      });
    builder
      .addCase(patchPriorityTemplatesByID.pending, (state) => {
        state.patchPriorityTemplatesByIDState = {
          loading: true,
          success: false,
          error: false,
          policyTemplatesId: null as string | null,
          Priority: null as number | null
        };
      })
      .addCase(patchPriorityTemplatesByID.fulfilled, (state, action) => {
        state.patchPriorityTemplatesByIDState = {
          loading: false,
          success: true,
          error: false,
          policyTemplatesId: action.payload.policyTemplatesId,
          Priority: action.payload.Priority,
        };
      })
      .addCase(patchPriorityTemplatesByID.rejected, (state) => {
        state.patchPriorityTemplatesByIDState = {
          loading: false,
          success: false,
          error: true,
          policyTemplatesId: null as string | null,
          Priority: null as number | null
        };
      });
  },
});
export const {
  resetDeletePolicyTemplatesByID,
  resetPatchPriorityTemplatesByIDState
} = mdmPolicyTemplatesDataSlice.actions

export default mdmPolicyTemplatesDataSlice.reducer;
